export default __webpack_public_path__ + "static/media/woman_final.9d14f5de.png";